import { useEffect } from "react";
import { ClientOverviewRepositoryImpl } from "../../data/repositories/ClientOverviewRepositoryImpl";
import { GetRevenueBootstrapUseCase } from "../../domain/use-cases/GetRevenueBootstrapUseCase";
import {
  getRevenueBootstrapData,
  getRevenueBootstrapError,
  getRevenueBootstrapPromise,
  setRevenueBootstrapData,
  setRevenueBootstrapError,
  setRevenueBootstrapPromise,
} from "../state/revenueBootstrapStore";

const repository = new ClientOverviewRepositoryImpl();
const useCase = new GetRevenueBootstrapUseCase(repository);

/**
 * Triggers a single fetch of Revenue page bootstrap payload (deduped across hooks).
 */
export function useRevenueBootstrap(): void {
  useEffect(() => {
    if (getRevenueBootstrapData() || getRevenueBootstrapError()) {
      return;
    }

    if (!getRevenueBootstrapPromise()) {
      const promise = useCase.execute();
      setRevenueBootstrapPromise(promise);
      promise
        .then((entity) => {
          setRevenueBootstrapError(null);
          setRevenueBootstrapData(entity);
        })
        .catch((err) => {
          const message =
            err instanceof Error ? err.message : "Failed to load revenue bootstrap";
          setRevenueBootstrapError(message);
        })
        .finally(() => {
          setRevenueBootstrapPromise(null);
        });
    }
  }, []);
}
